import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { RadioGroupInput, RadioGroupOutput } from '@trackback/widgets';
import { combineLatest } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { BaseFormControlWidgetComponent } from './base-form-control-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

@Component({
  selector: 'tb-radio-group',
  template: `
    <mat-radio-group
      [class]="classes"
      [formControl]="_formControl"
      [required]="input.required"
      (blur)="onBlur($event)"
      color="primary"
      [class.vertical]="input.vertical | parse: context | async"
    >
      @for (option of parsedOptions$ | async; track $index) {
        <mat-radio-button [value]="option.value" [disabled]="option.disabled">{{
          option.label | parse: context | async
        }}</mat-radio-button>
      }
    </mat-radio-group>
  `,
  styles: `
    tb-radio-group {
      display: inline-block;

      > mat-radio-group {
        display: flex;
        width: 100%;

        &.vertical {
          flex-direction: column;
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    AsyncPipe,
    ParsePipe,
    MatRadioGroup,
    MatRadioButton,
  ],
})
export default class RadioGroupComponent extends BaseFormControlWidgetComponent<
  RadioGroupInput,
  RadioGroupOutput
> {
  public readonly parsedOptions$ = combineLatest([
    this.input$,
    this.context$,
  ]).pipe(
    switchMap(([input, context]) =>
      this._parser.parse(input && input.options, {
        context,
        log:
          !this._config || !this._config.PRODUCTION ? console.log : undefined,
      })
    ),
    shareReplay({
      bufferSize: 1,
      refCount: true,
    })
  );
}
